import api from "@core/plugins/api";

const getEtablissementsUrl = () => `/multi-account/et/supervisor/sub-etabs`;
const getMultiAccountSupervisorDataUrl = (id) => `/multi-account/et/supervisor/sub-etab-access/${id}`;
const getMultiAccountTypeformLinkUrl = () => `/multi-account/et/request-link`;

export class MultiAccountService {
  static async getEtablissements() {
    try {
      const { data } = await api.private.get(getEtablissementsUrl());
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getMultiAccountSupervisorData(id) {
    try {
      const { data } = await api.private.get(getMultiAccountSupervisorDataUrl(id));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getMultiAccountTypeformLink() {
    try {
      const { data } = await api.private.get(getMultiAccountTypeformLinkUrl());
      return data;
    } catch (error) {
      throw error;
    }
  }
}
